module.exports = __webpack_public_path__ + "img/Lorient.c95cbdda.png";